import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardCommunicationService {
  private refreshTransactionHistorySource = new Subject<void>();

  // Observable that components can subscribe to
  refreshTransactionHistory$ = this.refreshTransactionHistorySource.asObservable();

  // Method to trigger refresh
  triggerTransactionHistoryRefresh() {
    this.refreshTransactionHistorySource.next();
  }
}
